"use client";

import styled from "@emotion/styled";
import { Radio as BaseRadio } from "@mui/material";

const Radio = styled(BaseRadio)(({ theme }) => ({
  "&.Mui-checked": { color: theme.palette.primary.verylight },
}));

export default Radio;
